export default [
    {
        key: 'test',
        path: '/mock/9286/api/v1/vip/homepage',
        origin: "VITE_MOCK_HOST"
    },
    {
        key: 'kconf',
        path: '/node/api/kconf/',
        origin: "VITE_VIP_FE_HOST"
    },
    {
        key: 'getlist',
        path: '/api/v1/coupon/game/coupons',
        origin: "VITE_VIP_RD_HOST"
    },
    {
        key: 'submitDelete',
        path: '/game/account/submit-delete',
        origin: "VITE_SDK_HOST"
    },
    {
        key: 'getDownloadInfo',
        path: '/rest/w/game/center/gameDetail',
        origin: "VITE_GAME_CENTER_HOST"
    },
    {
        key: 'getGiftList',
        path: '/rest/gd/activity/sign/reward',
        origin: "VITE_TASK_CENTER_HOST"
    },
    {
        key: 'getLocation',
        path: '/rest/gd/activity/reward/wangzhe/jumplink',
        origin: "VITE_TASK_CENTER_HOST"
    },
    {
        key: 'getReward',
        path: '/rest/gd/activity/sign/reward',
        origin: "VITE_TASK_CENTER_HOST"
    },
    {
        key: 'updateMission',
        path: '/rest/gd/activity/task/self-report',
        origin: "VITE_TASK_CENTER_HOST"
    },
    {
        key: 'getGiftDetail',
        path: '/rest/gd/activity/task/status-by-task/',
        origin: "VITE_TASK_CENTER_HOST"
    },
    {
        key: 'getTaskReward',
        path: '/rest/gd/activity/task/take-reward',
        origin: "VITE_TASK_CENTER_HOST"
    },
    {
        key: 'getMatchConfig',
        path: '/livepk/matchConfig',
        origin: "VITE_GAME_HOST"
    },
    {
        key: 'getRanking',
        path: '/livepk/ranking',
        origin: "VITE_GAME_HOST"
    },
    {
        key: 'getMatchInfo',
        path: '/livepk/matchInfo',
        origin: "VITE_GAME_HOST"
    },
    {
        key: 'getMarqueeConfig',
        path: '/livepk/marqueeConfig',
        origin: "VITE_GAME_HOST"
    },
    {
        key: 'getMarqueeInfo',
        path: '/livepk/marquee',
        origin: "VITE_GAME_HOST"
    },
    {
        key: 'getRecord',
        path: '/livepk/record',
        origin: "VITE_GAME_HOST"
    },
    {
        key: 'getTeamRanking',
        path: '/livepk/teamRanking',
        origin: "VITE_GAME_HOST"
    }
];
